var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "error-page" }, [
    _c("h4", { staticClass: "pa-4 white--text" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.error_msg ||
              "Errore inatteso. Refreshare la pagina. Se il problema persiste contattare il supporto"
          ) +
          "\n  "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }